import {AppBar, Typography, css, styled} from '@mui/material';
import {HeaderStyleProps} from './types';

const StyledHeader = styled(AppBar)<HeaderStyleProps>`
	position: relative;
	box-shadow: none;

	${({theme, customPadding, customGap}) => css`
		padding: ${customPadding || '16px'};
		gap: ${customGap || '16px'};

		${theme.breakpoints.up('md')} {
			padding: ${customPadding || '32px'};
		}

		${theme.breakpoints.between('sm', 'md')} {
			padding-inline: 120px;
			gap: 8px;
		}
	`};
`;

const HeaderTitle = styled(Typography)`
	margin-left: 20px;
	flex: 1;
`;

const HeaderSubTitle = styled(Typography)`
	white-space: pre-line;
`;

export {StyledHeader, HeaderTitle, HeaderSubTitle};
